import RestClient from './RestClient';
import { User } from '../../models';

class Users extends RestClient {
    constructor() {
        super({
            model: User,
            entryPoint: 'user',
            resource: 'user',
            resources: 'users',
            sortBy: 'fullname'
        });

        this.ENABLE_PATH  = '/enable/id';
        this.DISABLE_PATH = '/disable/id';
    }

    disable(userId) {
        const url = `/${this.entryPoint}${this.DISABLE_PATH}/${userId}`;
        return this.POST(url)
            .then(response => response.json())
            .then(json => {
                if (json.user) {
                    json.user = new User(json.user);
                    return json;
                }
                throw this._buildApiError(json, 'Unable to disable user');
            });
    }

    enable(userId) {
        const url = `/${this.entryPoint}${this.ENABLE_PATH}/${userId}`;
        return this.POST(url)
            .then(response => response.json())
            .then(json => {
                if (json.user) {
                    json.user = new User(json.user);
                    return json;
                }
                throw this._buildApiError(json, 'Unable to enable user');
            });
    }

    update(data) {
        return this.PUT(
                `/${this.entryPoint}${this.UPDATE_PATH}/${data[this.idField]}`,
                { [this.resource]: data }
            ).then(response => response.json())
            .then(json => {
                if (json[this.resource]) {
                    json[this.resource] = new this.model(json[this.resource]);
                    return json;
                }

                throw this._buildApiError(json, `Unable to update ${this.resource}`);
            });
    }
}

const UsersApi = new Users();

export default UsersApi;
